import {withRouter, NavLink} from 'react-router-dom'
import {IoMdHome} from 'react-icons/io'
import {HiFire} from 'react-icons/hi' 
import {SiYoutubegaming} from 'react-icons/si'
import {RiPlayListAddFill} from 'react-icons/ri'
import ThemeContext from '../ThemeContext'
import './index.css'


const LeftPortion = () => (
  <ThemeContext.Consumer>
    {value => {
      const {activeThemeIsLight} = value
      const theme = activeThemeIsLight ? 'light-theme' : 'dark-theme'

      return (
        <nav className={`left-portion-container ${theme}`}>
          <div className="left-portion-content">
            <ul className="nav-links-list">
              
              <li>
                <NavLink
                  exact
                  to="/"
                  className="nav-link"
                  activeClassName="active-link"
                >
                  <IoMdHome size={22} />
                  <span className="link-text">Home</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/trending"
                  className="nav-link"
                  activeClassName="active-link"
                >
                  <HiFire size={22} />
                  <span className="link-text">Trending</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/gaming"
                  className="nav-link"
                  activeClassName="active-link"
                >
                  <SiYoutubegaming size={22} />
                  <span className="link-text">Gaming</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/saved-videos"
                  className="nav-link"
                  activeClassName="active-link"
                >
                  <RiPlayListAddFill size={22} />
                  <span className="link-text">Saved videos</span>
                </NavLink>
              </li>
            </ul>

            <div className="contact-us-section">
              <p className="contact-heading">CONTACT US</p>
              <div className="social-media-icons">
                <img
                  alt="facebook logo"
                  className="social-logo"
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-facebook-logo-img.png"
                />
                <img
                  alt="twitter logo"
                  className="social-logo"
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-twitter-logo-img.png"
                />
                <img
                  alt="linked in logo"
                  className="social-logo"
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-linked-in-logo-img.png"
                />
              </div>
              <p className="contact-description">
                Enjoy! Now to see your channels and recommendations!
              </p>
            </div>
          </div>
        </nav>
      )
    }}
  </ThemeContext.Consumer>
)

export default withRouter(LeftPortion)
